import styled from "styled-components"

export const MiddleContainer = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
`
